namespace GeniuzPOS.InitialData {
    export class PsShopGroupColumns {
        static columnsKey = 'InitialData.PsShopGroup';
    }
}
